export const aprToString = (apr: number): string => `${apr >= 0 ? apr : '--'}% APR`;

export const milesToString = (miles: number): string => `${miles ? miles.toLocaleString('en-US') : 0} Miles`;

export const milesToStringShort = (miles: number | string): string => {
    if (!miles) return '0 mi';
    return `${Number.parseInt(miles.toString(), 10).toLocaleString('en-US')} mi`;
};
